module.exports = __webpack_public_path__ + "static/img/insta.9177e81d.png";